
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CharacterBasicAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Character"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dead"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"statut"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"attributes"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"strength"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dexterity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stamina"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"charisma"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"manipulation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"appearance"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"perception"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"intelligence"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"wits"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"alertness"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"animal_ken"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"academics"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"athletics"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"crafts"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"computer"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"brawl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"drive"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"finance"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dodge"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"etiquette"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"investigation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"empathy"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"firearms"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"law"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"expression"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"melee"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"linguistics"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"intimidation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"performance"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"medicine"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"leadership"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"security"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"occult"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"streetwise"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stealth"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"politics"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subterfuge"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"survival"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"science"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"humanity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"humanity_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"money"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"aura"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"base_aura"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"attributes"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":699}};
    doc.loc.source = {"body":"fragment CharacterBasicAttributes on Character {\n    slug name dead\n    statut {data {id attributes { name }}}\n    # ATTRIBUTES\n    strength dexterity stamina\n    charisma manipulation appearance\n    perception intelligence wits\n    # ABILITIES\n    alertness animal_ken academics\n    athletics crafts computer\n    brawl drive finance\n    dodge etiquette investigation\n    empathy firearms law\n    expression melee linguistics\n    intimidation performance medicine\n    leadership security occult\n    streetwise stealth politics\n    subterfuge survival science\n\n    humanity\n    humanity_name\n\n    #other\n    money\n\n    aura\n    base_aura {\n        data { id attributes { name description } }\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["CharacterBasicAttributes"] = oneQuery(doc, "CharacterBasicAttributes");
        
